/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { ofType } from 'redux-observable';
import { switchMap, catchError } from 'rxjs/operators';
import { fromPromise } from 'rxjs/observable/fromPromise';
import { reactLocalStorage } from 'reactjs-localstorage';

import { postOtpSendCodeDone, postOtpSendCodeFail, postOtpVerifyDone, postOtpVerifyFail } from '@src/store/actions/otp';
import { setToken, checkLoginCall } from '@src/store/actions/session';
import { toastShowCall } from '@src/store/actions/ui';
import { POST_OTP_SEND_CODE_CALL, POST_OTP_VERIFY_CALL } from '@src/store/types/otp';
import { TOAST_TYPE_ERROR, TOAST_TYPE_SUCCESS } from '@src/const/common';
import { normalizeErrorType } from '@src/utils/normalizeErrorType';
import { otp } from '@src/services';

// 這些 action 的「email duplicated」由呼叫端顯示欄位錯誤,不出全域 toast
const EMAIL_DUPLICATED_INLINE_ACTIONS = ['signup', 'front-desk/validate-email'];

// TC-19305：企業試用期已過且簡訊儲值餘額不足時,BE 會回 400 帶這個 error_type
// (TC-19302,涵蓋 otp/mobile/{action} 與 otp/mobile/front-desk/{action})。
// 六個入口(註冊/登入/個人資料綁定/變更手機,各含首次與重新發送)都收斂在這支 epic,
// 所以阻擋提示只需要在這裡處理一次。
// 依 spec 不區分錯誤原因、不揭露企業的計費或餘額狀態,也不引導改用其他註冊/登入方式。
const ERROR_TYPE_NOTIFICATION_BALANCE_INSUFFICIENT = 'notification_balance_insufficient';

// OTP 發送驗證碼
export const postOtpSendCodeEpic = action$ => action$.pipe(
	ofType(POST_OTP_SEND_CODE_CALL),
	switchMap(({ payload: { onSuccess, onError, action, ...form } }) => fromPromise(otp.postOtpSendCodeCall({ action, form })).pipe(
		switchMap(res => {
			if (onSuccess) onSuccess(res);
			return [postOtpSendCodeDone(res)];
		}),
		catchError(err => {
			const errorData = err?.response?.data;
			if (onError) onError(err);
			const resultActions = [postOtpSendCodeFail(errorData)];
			if (err?.response?.status === 429) {
				resultActions.push(toastShowCall({ message: 'share:auth:otp:error:rate_limit', type: TOAST_TYPE_ERROR }));
			} else if (normalizeErrorType(errorData?.error_type) === ERROR_TYPE_NOTIFICATION_BALANCE_INSUFFICIENT) {
				resultActions.push(toastShowCall({ message: 'share:auth:otp:error:notification_balance_insufficient', type: TOAST_TYPE_ERROR }));
			} else if (normalizeErrorType(errorData?.error_type) === 'email duplicated' && !EMAIL_DUPLICATED_INLINE_ACTIONS.includes(action)) {
				resultActions.push(toastShowCall({ message: 'share:auth:otp:error:email_duplicated', type: TOAST_TYPE_ERROR }));
			}
			return resultActions;
		}),
	)),
);

// OTP 驗證碼驗證
export const postOtpVerifyEpic = action$ => action$.pipe(
	ofType(POST_OTP_VERIFY_CALL),
	switchMap(({ payload: { onSuccess, onError, autoLogin, action, ...form } }) => fromPromise(otp.postOtpVerifyCall({ action, form })).pipe(
		switchMap(res => {
			const resultActions = [postOtpVerifyDone(res)];
			if (onSuccess) onSuccess(res);
			if (autoLogin && res.access_token) {
				if (res?.is_registering && res?.registration_link_id) {
					reactLocalStorage.set('registrationLinkIdAfterLogin', res.registration_link_id);
				} else {
					reactLocalStorage.remove('registrationLinkIdAfterLogin');
				}
				resultActions.unshift(
					setToken({ token: res.access_token, isJwtToken: true }),
					checkLoginCall({ fromLogin: true }),
					toastShowCall({ type: TOAST_TYPE_SUCCESS, message: 'share:auth:message:login_success' }),
				);
			}
			return resultActions;
		}),
		catchError(err => {
			if (onError) onError(err);
			return [postOtpVerifyFail(err?.response?.data)];
		}),
	)),
);
